module.exports = __webpack_public_path__ + "img/f_1_1.80aaf7ff.png";